import dayjs from "dayjs"
import { History } from "../../../../../../../service/dashboard/response"
import { Constants } from "../../../../../../../utils/constants"
import { Item, ObjectGeneric } from "../../../../../../../utils/types/generals"
import { es } from "date-fns/locale"
import { format } from "date-fns"
import { deleteDecimalsWithZero } from "../../../../../../../utils/methods/removeDecimals"

const formatResponse = ({response, values,}:{response: History, values: ObjectGeneric; intervale: string}) => {
    const lastDate = response?.hits?.hits?.[0]?._source
    const updateDate = lastDate?.fecha
        ? `Semana: ${lastDate.semana} - ${format(
            dayjs(lastDate?.fecha).toDate(),
            Constants.humanFormat,
            { locale: es }
        )}`
        : ''
    
    const cuestionarioResultadoMap: {[key: string]: number} = {}
    response?.hits?.hits?.forEach((hit: any) => {
        const source = hit._source
        if (source?.unidad_id && source?.cuestionario_resultado !== undefined) {
            cuestionarioResultadoMap[source.unidad_id] = source.cuestionario_resultado
        }
    })

    const hits =
        response?.aggregations?.registros_diarios?.buckets?.map((item: any, index) => {
            const unit = values.unit?.find((unitItems: Item) => unitItems.value == item.key)
            const cuestionarioResultado = cuestionarioResultadoMap[item.key]

            return {
                id: item.key,
                unit: unit?.name,
                keyCode: unit?.keyCode,
                avance: item?.promedio_avance?.value || item?.promedio_avance?.value == '0' ? `${deleteDecimalsWithZero(Number(item?.promedio_avance?.value).toFixed(2))}%` : null,
                cuestionario_resultado: item?.cuestionario_resultado?.value || item?.cuestionario_resultado?.value == '0' ? `${deleteDecimalsWithZero(Number(item?.cuestionario_resultado?.value).toFixed(4))}` : null,
                }
        }) ?? []

    return { hits, updateDate}
}

export { formatResponse }
